import { RenderSize_Full_getInstancer1do7w9ydi0t as RenderSize_Full_getInstance } from './LocalTimeRender.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  Companion_getInstance3qu5ydsg8audm as Companion_getInstance,
  toInstant2q17i3aluy6ks as toInstant,
} from '../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/TimeZone.mjs';
import { toJSDate14542kwfw0zmu as toJSDate } from '../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/Converters.mjs';
import { noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { atTime2v4vw3esgoteo as atTime } from '../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/LocalDate.mjs';
import { atDatef446kt6vbj70 as atDate } from '../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/LocalTime.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function renderToString(_this__u8e3s4, size, includeWeekday, includeYear, includeEra) {
  size = size === VOID ? RenderSize_Full_getInstance() : size;
  includeWeekday = includeWeekday === VOID ? false : includeWeekday;
  includeYear = includeYear === VOID ? true : includeYear;
  includeEra = includeEra === VOID ? false : includeEra;
  var tmp = toJSDate(toInstant(_this__u8e3s4, Companion_getInstance().q27()));
  // Inline function 'kotlin.js.dateLocaleOptions' call
  // Inline function 'kotlin.js.unsafeCast' call
  var result = new Object();
  result.day = 'numeric';
  var tmp_0;
  switch (size.b4_1) {
    case 0:
      tmp_0 = 'numeric';
      break;
    case 1:
      tmp_0 = 'short';
      break;
    case 2:
      tmp_0 = 'long';
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  result.month = tmp_0;
  if (includeWeekday) {
    var tmp_1;
    switch (size.b4_1) {
      case 0:
        tmp_1 = 'short';
        break;
      case 1:
        tmp_1 = 'short';
        break;
      case 2:
        tmp_1 = 'long';
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    result.weekday = tmp_1;
  }
  if (includeYear) {
    var tmp_2;
    switch (size.b4_1) {
      case 0:
        tmp_2 = 'numeric';
        break;
      case 1:
        tmp_2 = 'numeric';
        break;
      case 2:
        tmp_2 = 'numeric';
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    result.year = tmp_2;
  }
  if (includeEra) {
    result.era = 'short';
  }
  result.hour = 'numeric';
  result.minute = 'numeric';
  return tmp.toLocaleString(VOID, result);
}
function renderToString_0(_this__u8e3s4, size, includeWeekday, includeYear, includeEra) {
  size = size === VOID ? RenderSize_Full_getInstance() : size;
  includeWeekday = includeWeekday === VOID ? false : includeWeekday;
  includeYear = includeYear === VOID ? true : includeYear;
  includeEra = includeEra === VOID ? false : includeEra;
  var tmp = toJSDate(toInstant(atTime(_this__u8e3s4, 12, 0), Companion_getInstance().q27()));
  // Inline function 'kotlin.js.dateLocaleOptions' call
  // Inline function 'kotlin.js.unsafeCast' call
  var result = new Object();
  result.day = 'numeric';
  var tmp_0;
  switch (size.b4_1) {
    case 0:
      tmp_0 = 'numeric';
      break;
    case 1:
      tmp_0 = 'short';
      break;
    case 2:
      tmp_0 = 'long';
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  result.month = tmp_0;
  if (includeWeekday) {
    var tmp_1;
    switch (size.b4_1) {
      case 0:
        tmp_1 = 'short';
        break;
      case 1:
        tmp_1 = 'short';
        break;
      case 2:
        tmp_1 = 'long';
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    result.weekday = tmp_1;
  }
  if (includeYear) {
    var tmp_2;
    switch (size.b4_1) {
      case 0:
        tmp_2 = 'numeric';
        break;
      case 1:
        tmp_2 = 'numeric';
        break;
      case 2:
        tmp_2 = 'numeric';
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    result.year = tmp_2;
  }
  if (includeEra) {
    result.era = 'short';
  }
  return tmp.toLocaleDateString(VOID, result);
}
function renderToString_1(_this__u8e3s4, size) {
  size = size === VOID ? RenderSize_Full_getInstance() : size;
  var tmp = toJSDate(toInstant(atDate(_this__u8e3s4, 1970, 1, 1), Companion_getInstance().q27()));
  // Inline function 'kotlin.js.dateLocaleOptions' call
  // Inline function 'kotlin.js.unsafeCast' call
  var result = new Object();
  result.hour = 'numeric';
  result.minute = 'numeric';
  return tmp.toLocaleTimeString(VOID, result);
}
//region block: exports
export {
  renderToString_0 as renderToString2kyj9dlz89tdi,
  renderToString_1 as renderToString1ghq9c47uw4e8,
  renderToString as renderToString20fhv3rgk9b94,
};
//endregion

//# sourceMappingURL=LocalTimeRender.js.mjs.map
